import DOMPurify from "dompurify";

/**
 * Sanitiza HTML vindo da IA antes de injetar via `dangerouslySetInnerHTML`.
 *
 * As respostas estruturadas da Responses API (chat Nina, exam-consultant,
 * exam-analysis, signs-symptoms) trazem `content_html` que é renderizado
 * direto no DOM. Como o prompt da paciente (e em alguns casos o conteúdo
 * de PDFs uploadados) influencia a saída, é trivial para um atacante
 * forçar prompt injection que produza `<img src=x onerror=...>` ou similar.
 *
 * Esta função aplica uma allowlist conservadora compatível com as tags
 * documentadas nas instructions da Nina: títulos, parágrafos, listas,
 * ênfase, quebras de linha. Removemos qualquer evento inline, scripts,
 * iframes, e atributos perigosos como `srcset`, `onerror`, `onclick` etc.
 */
const ALLOWED_TAGS = [
  "h1", "h2", "h3", "h4", "h5", "h6",
  "p", "br", "hr",
  "strong", "em", "b", "i", "u",
  "ul", "ol", "li",
  "blockquote",
  "table", "thead", "tbody", "tr", "th", "td",
  "code", "pre",
  "span", "div",
];

const ALLOWED_ATTR = ["class", "style"];

export function sanitizeHtml(input: string | null | undefined): string {
  if (!input) return "";
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "link", "meta", "style"],
    FORBID_ATTR: ["srcset", "src", "href"],
  });
}
